angular.module('bmsApp.merrymaids.job')
	.controller('MMJobIndexCtrl', [
		'$rootScope',
		'$state',
		'$scope',
		'$cookies',
		'$localStorage',
		'$q',
		'NgTableParams',
		'MMJobSvc',
		'QuoteStatusSvc',
		'InstanceSvc',
		'LicenseOptionsSvc',
		'$q',
		function ($rootScope,
				  $state,
				  $scope,
				  $cookies,
				  $localStorage,
				  $q,
				  NgTableParams,
				  MMJobSvc,
				  QuoteStatusSvc,
				  InstanceSvc,
				  LicenseOptionsSvc,
				  $q) {

			var quoteIndexStateName = 'main.merrymaids.quote.index';
			var jobIndexStateName = 'main.merrymaids.job.index';



			var defaultJobParams = function () {
				var params = {
					page: 1, // show first page
					count: $scope.config.table.params.count, // count per page
					sorting: {
						surname: 'asc'
					},
					filter: {
						search: '',
						licences: null,
						licenceType: null,
					}
				};
				if ($state.is(quoteIndexStateName)) {
					$scope.MMJobMainCtrl.jobOrQuote = 'quote';
					self.filterInputPlaceholder = 'Filter Quotes';
					params.filter.converted = 0;
					// Default quote statuses to "Open"
					params.filter.quoteStatuses = [
						1
					];
				}
				if ($state.is(jobIndexStateName)) {
					$scope.MMJobMainCtrl.jobOrQuote = 'job';
					self.filterInputPlaceholder = 'Filter Jobs';
					params.filter.converted = 1;
					params.filter.jobStatus = true;
					params.filter.order_confirmed = true;
				}
				return params;
			};

			var initialJobParams = function () {
				var stored;
				if ($state.is(quoteIndexStateName)) {
					stored = $localStorage.mmQuoteIndexParams;
				}
				if ($state.is(jobIndexStateName)) {
					stored = $localStorage.mmJobIndexParams;
				}
				if (angular.isObject(stored)) {
					return angular.extend({}, defaultJobParams(), stored);
				}
				else {
					return angular.extend({}, defaultJobParams());
				}
			};

			function init() {
				self.loading = true;
				self.isQuoteIndex = $state.is(quoteIndexStateName);
				self.isJobIndex = $state.is(jobIndexStateName);
				self.ecomEnabled = InstanceSvc.instance.ecomEnabled();

				var promises = {
					licenseOptions: LicenseOptionsSvc.license(),
				};
				$q.all(promises)
					.then(function (response) {
						$scope.licenseOptions = response.licenseOptions.data.options;
					});

				var tableParams = initialJobParams();

				// copy the filters to a workable state
				self.table.tempFilters = angular.copy(tableParams.filter);

				var tableOptions = {
					total: 0, // length of data
					counts: $scope.config.table.settings.counts, // available page counts
					getData: function ($defer, params) {
						self.table.updating = true;
						MMJobSvc.index(params.$params)
							.then(function (response) {
								params.total(response.data.job_filtered_count);
								$defer.resolve(response.data.job_collection);
								$rootScope.$broadcast('mmJobIndexChanged', {
									totalCount: response.data.job_total_count,
									displaying: response.data.job_collection.length,
									over28Days: response.data.job_total_over_28_days,
									filtered_count: response.data.job_filtered_count,
									quoteIndex: $state.is(quoteIndexStateName),
								});
								// Check if we've exceeded our page size, if we have, go back
								if (response.data.job_filtered_count > 0 && !response.data.job_collection.length) {
									let newParams = angular.copy(self.table.params.$params);
									newParams.page--;
									angular.extend(self.table.params.$params, newParams);
								}
								self.table.updating = false;
							});
					}
				};
				// angular.merge(tableParams, {
				// 	filter: {
				// 		converted: 1
				// 	}
				// });
				self.table.params = new NgTableParams(tableParams, tableOptions);

				// Store the table params whenever anything changes
				$scope.$watch(function () {
					return self.table.params.$params;
				}, function (value) {
					if (angular.isObject(value)) {
						if ($state.is(quoteIndexStateName)) {
							$localStorage.mmQuoteIndexParams = value;
						}
						if ($state.is(jobIndexStateName)) {
							$localStorage.mmJobIndexParams = value;
						}
					}
				}, true);

				$q.all([
					options()
				])
					.then(function () {
						self.loading = false;
					});
			}

			function options() {
				return $q.all({
					quoteStatusOptions: QuoteStatusSvc.options()
						.then(function (response) {
							self.table.options.quoteStatus = response.data.options;
						})
				});
			}

			function filterApply() {
				angular.extend(self.table.params.$params.filter, self.table.tempFilters);
			}

			function filterReset() {
				angular.extend(self.table.params.$params, defaultJobParams());
				angular.extend(self.table.tempFilters, defaultJobParams().filter);
			}

			function jobClicked(job) {
				if (job.converted) {
					$state.go('main.merrymaids.job.read', {
						jobId: job.id
					});
				}
				else {
					$state.go('main.merrymaids.quote.read', {
						jobId: job.id
					});
				}
			}

			function onSearchChanged() {
				self.table.params.$params.filter.search = self.table.tempFilters.search;
			}

			$scope.$on('mmJobIndexExport', function () {
				var params = angular.copy(self.table.params.$params);
				MMJobSvc.export(params);
			});
			
			var self = $scope.MMJobIndexCtrl = {
				methods: {
					init: init,
					filterApply: filterApply,
					filterReset: filterReset,
					jobClicked: jobClicked
				},
				handlers: {
					onSearchChanged: onSearchChanged
				},
				table: {
					// params: new NgTableParams(tableParams, tableOptions),
					options: {},
					tempFilters: {},
					updating: false
				},
				isQuoteIndex: false,
				isJobIndex: false,
				loading: false
			};

		}
	]);
